export default "__VITE_ASSET__05e42c4b__"